import { useCatalog } from '../api/queries.js';
import { EmptyState } from '../components/empty-state.js';
import { ErrorState } from '../components/error-state.js';
import { KitCard } from '../components/kit-card.js';
import { PageHeader } from '../components/page-header.js';
import { StockOrigin } from '../components/stock-origin.js';
import { formatDateTime } from '../lib/format.js';

const SKELETON_CARDS = 6;

function CatalogSkeleton() {
  return (
    <div
      aria-busy="true"
      aria-label="Cargando catálogo"
      className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
    >
      {Array.from({ length: SKELETON_CARDS }, (_, index) => (
        <div key={index} className="h-48 animate-pulse rounded-card bg-muted" />
      ))}
    </div>
  );
}

export function CatalogPage() {
  const catalog = useCatalog();
  return (
    <>
      <PageHeader
        title="Kits clínicos"
        description="Precio vigente de mercado y stock real de nuestra bodega."
      />
      <StockOrigin />
      {catalog.isPending && <CatalogSkeleton />}
      {catalog.isError && (
        <ErrorState
          message="No pudimos cargar el catálogo."
          onRetry={() => void catalog.refetch()}
        />
      )}
      {catalog.isSuccess && catalog.data.kits.length === 0 && (
        <EmptyState message="Aún no hay kits en el catálogo." />
      )}
      {catalog.isSuccess && catalog.data.kits.length > 0 && (
        <>
          <p className="mb-4 text-sm text-muted-foreground" aria-live="polite">
            {catalog.data.pricesUpdatedAt === null
              ? 'Precios de mercado no disponibles en este momento.'
              : `Precios actualizados: ${formatDateTime(catalog.data.pricesUpdatedAt)}${catalog.data.pricesStale ? ' (desactualizados)' : ''}`}
          </p>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {catalog.data.kits.map((kit) => (
              <KitCard key={kit.sku} kit={kit} />
            ))}
          </div>
        </>
      )}
    </>
  );
}
